module.exports = __webpack_public_path__ + "img/s00176.075a0846.png";